export default __webpack_public_path__ + "static/landing2-268f10a53e25868474e544ff5f2f28f7.jpg";